import { useQuery } from "@tanstack/react-query";

import { inclusiveEducationContentKeys } from "../../../../redux/services/inclusiveEducationContent";

import { getInclusiveEducationContentApiCall } from "./InclusiveEducationVideo/utils.api";

export const useGetInclusiveEducationContent = (payload) => {
  const { chapterId, moduleId, courseId, languageId } = payload;

  return useQuery({
    queryKey: inclusiveEducationContentKeys.getInclusiveEducationContentKeys(),
    queryFn: () =>
      getInclusiveEducationContentApiCall({
        chapterId,
        moduleId,
        courseId,
        languageId,
      }),
  });
};
